module.exports = __webpack_public_path__ + "img/blog-1.96ccdaf3.png";